import { render, staticRenderFns } from "./nepaPolicy.vue?vue&type=template&id=30662024&scoped=true"
import script from "./nepaPolicy.vue?vue&type=script&lang=js"
export * from "./nepaPolicy.vue?vue&type=script&lang=js"
import style0 from "./nepaPolicy.vue?vue&type=style&index=0&id=30662024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30662024",
  null
  
)

export default component.exports